import { render } from "./DTablePagination.vue?vue&type=template&id=25a70283"
import script from "./DTablePagination.vue?vue&type=script&lang=js"
export * from "./DTablePagination.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__